import {
  configurationManagerPageDe,
  configurationManagerPageEn,
  configurationManagerPagePtBr,
  configurationManagerPageEs,
  configurationManagerPageIt,
  configurationManagerPageZhHans,
  configurationManagerPageNl,
  configurationManagerPageTr,
} from "./configuration-manager-page.i18n";
import {
  dashboardsPagePtBr,
  dashboardsPageDe,
  dashboardsPageEn,
  dashboardsPageEs,
  dashboardsPageIt,
  dashboardsPageNl,
  dashboardsPageZhHans,
  dashboardsPageTr,
} from "./dashboards-page.i18n";
import {
  loginDe,
  loginEn,
  loginPtBr,
  loginEs,
  loginIt,
  loginZhHans,
  loginNl,
  loginTr,
} from "./login.i18n";
import {
  logoutDe,
  logoutEn,
  logoutPtBr,
  logoutEs,
  logoutIt,
  logoutZhHans,
  logoutNl,
  logoutTr,
} from "./logout.i18n";
import {
  nodeManagerPageDe,
  nodeManagerPageEn,
  nodeManagerPagePtBr,
  nodeManagerPageEs,
  nodeManagerPageIt,
  nodeManagerPageZhHans,
  nodeManagerPageNl,
  nodeManagerPageTr,
} from "./node-manager-page.i18n";
import {
  permissionMissingDe,
  permissionMissingEn,
  permissionMissingPtBr,
  permissionMissingEs,
  permissionMissingIt,
  permissionMissingZhHans,
  permissionMissingNl,
  permissionMissingTr,
} from "./permission-missing-page.i18n";
import {
  refreshTokenExpiredErrorDe,
  refreshTokenExpiredErrorEn,
  refreshTokenExpiredErrorPtBr,
  refreshTokenExpiredErrorEs,
  refreshTokenExpiredErrorIt,
  refreshTokenExpiredErrorZhHans,
  refreshTokenExpiredErrorNl,
  refreshTokenExpiredErrorTr,
} from "./refresh-token-expired-error-page.i18n";
import {
  serverErrorPageDe,
  serverErrorPageEn,
  serverErrorPagePtBr,
  serverErrorPageEs,
  serverErrorPageIt,
  serverErrorPageZhHans,
  serverErrorPageNl,
  serverErrorPageTr,
} from "./server-error-page.i18n";
import {
  thingsOsHomepageDe,
  thingsOsHomepageEn,
  thingsOsHomepagePtBr,
  thingsOsHomepageEs,
  thingsOsHomepageIt,
  thingsOsHomepageZhHans,
  thingsOsHomepageNl,
  thingsOsHomepageTr,
} from "./things-os-homepage.i18n";
import {
  ticketsPageDe,
  ticketsPageEn,
  ticketsPagePtBr,
  ticketsPageEs,
  ticketsPageIt,
  ticketsPageZhHans,
  ticketsPageNl,
  ticketsPageTr,
} from "./tickets-page.i18n";
import {
  userManagementPageDe,
  userManagementPageEn,
  userManagementPagePtBr,
  userManagementPageEs,
  userManagementPageIt,
  userManagementPageZhHans,
  userManagementPageNl,
  userManagementPageTr,
} from "./user-management-page.i18n";
import {
  vncpageDe,
  vncpageEn,
  vncpagePtBr,
  vncpageEs,
  vncpageIt,
  vncpageZhHans,
  vncpageNl,
  vncpageTr,
} from "./vnc-page.i18n";

export const englishPages = {
  ...configurationManagerPageEn,
  ...loginEn,
  ...logoutEn,
  ...nodeManagerPageEn,
  ...permissionMissingEn,
  ...refreshTokenExpiredErrorEn,
  ...serverErrorPageEn,
  ...thingsOsHomepageEn,
  ...ticketsPageEn,
  ...dashboardsPageEn,
  ...userManagementPageEn,
  ...vncpageEn,
};

export const brazilianPortuguesePages = {
  ...configurationManagerPagePtBr,
  ...loginPtBr,
  ...logoutPtBr,
  ...nodeManagerPagePtBr,
  ...permissionMissingPtBr,
  ...refreshTokenExpiredErrorPtBr,
  ...serverErrorPagePtBr,
  ...thingsOsHomepagePtBr,
  ...ticketsPagePtBr,
  ...dashboardsPagePtBr,
  ...userManagementPagePtBr,
  ...vncpagePtBr,
};

export const germanPages = {
  ...configurationManagerPageDe,
  ...loginDe,
  ...logoutDe,
  ...nodeManagerPageDe,
  ...permissionMissingDe,
  ...refreshTokenExpiredErrorDe,
  ...serverErrorPageDe,
  ...thingsOsHomepageDe,
  ...ticketsPageDe,
  ...dashboardsPageDe,
  ...userManagementPageDe,
  ...vncpageDe,
};

export const simplifiedChinesePages = {
  ...configurationManagerPageZhHans,
  ...loginZhHans,
  ...logoutZhHans,
  ...nodeManagerPageZhHans,
  ...permissionMissingZhHans,
  ...refreshTokenExpiredErrorZhHans,
  ...serverErrorPageZhHans,
  ...thingsOsHomepageZhHans,
  ...ticketsPageZhHans,
  ...dashboardsPageZhHans,
  ...userManagementPageZhHans,
  ...vncpageZhHans,
};

export const spanishPages = {
  ...configurationManagerPageEs,
  ...loginEs,
  ...logoutEs,
  ...nodeManagerPageEs,
  ...permissionMissingEs,
  ...refreshTokenExpiredErrorEs,
  ...serverErrorPageEs,
  ...thingsOsHomepageEs,
  ...ticketsPageEs,
  ...dashboardsPageEs,
  ...userManagementPageEs,
  ...vncpageEs,
};

export const italianPages = {
  ...configurationManagerPageIt,
  ...loginIt,
  ...logoutIt,
  ...nodeManagerPageIt,
  ...permissionMissingIt,
  ...refreshTokenExpiredErrorIt,
  ...serverErrorPageIt,
  ...thingsOsHomepageIt,
  ...ticketsPageIt,
  ...dashboardsPageIt,
  ...userManagementPageIt,
  ...vncpageIt,
};

export const dutchPages = {
  ...configurationManagerPageNl,
  ...loginNl,
  ...logoutNl,
  ...nodeManagerPageNl,
  ...permissionMissingNl,
  ...refreshTokenExpiredErrorNl,
  ...serverErrorPageNl,
  ...thingsOsHomepageNl,
  ...ticketsPageNl,
  ...dashboardsPageNl,
  ...userManagementPageNl,
  ...vncpageNl,
};

export const turkishPages = {
  ...configurationManagerPageTr,
  ...loginTr,
  ...logoutTr,
  ...nodeManagerPageTr,
  ...permissionMissingTr,
  ...refreshTokenExpiredErrorTr,
  ...serverErrorPageTr,
  ...thingsOsHomepageTr,
  ...ticketsPageTr,
  ...userManagementPageTr,
  ...vncpageTr,
  ...dashboardsPageTr,
};
